import "~/scss/pages/chair_page.scss";

$(() => {
    $("#research-axis").on("mouseover", () => {
        $("#research-axis i")[0].classList.add("fade-in-right");
    });
    $("#research-axis").on("mouseout", () => {
        $("#research-axis i")[0].classList.remove("fade-in-right");
    });
});